import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import LandingPage from "@/pages/LandingPage";
import IdentityShiftPage from "@/pages/IdentityShiftPage";
import CareerWealthPage from "@/pages/CareerWealthPage";
import AboutPage from "@/pages/AboutPage";
import CheckoutPage from "@/pages/CheckoutPage";
import ThankYouPage from "@/pages/ThankYouPage";
import DownloadsPage from "@/pages/DownloadsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import SellerInformationPage from "@/pages/SellerInformationPage";
import FreeGuidePage from "@/pages/FreeGuidePage";
import FreeGuideThankYouPage from "@/pages/FreeGuideThankYouPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/identity-shift" element={<IdentityShiftPage />} />
          <Route path="/career-wealth" element={<CareerWealthPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/seller-information" element={<SellerInformationPage />} />
          <Route path="/free-guide" element={<FreeGuidePage />} />
          <Route path="/free-guide-thank-you" element={<FreeGuideThankYouPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
